import { render, staticRenderFns } from "./pendingSettlement.vue?vue&type=template&id=205e2366&scoped=true"
import script from "./pendingSettlement.vue?vue&type=script&lang=js"
export * from "./pendingSettlement.vue?vue&type=script&lang=js"
import style0 from "./pendingSettlement.vue?vue&type=style&index=0&id=205e2366&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205e2366",
  null
  
)

export default component.exports